import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsSouthwestairlinesComponent } from './simple-icons-southwestairlines.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsSouthwestairlinesComponent ],
    exports:      [ SimpleIconsSouthwestairlinesComponent ],
    bootstrap:    []
})
export class SimpleIconsSouthwestairlinesModule {}
